import { render, staticRenderFns } from "./RecipeIcon.vue?vue&type=template&id=306f7130&scoped=true"
import script from "./RecipeIcon.vue?vue&type=script&lang=js"
export * from "./RecipeIcon.vue?vue&type=script&lang=js"
import style0 from "./RecipeIcon.vue?vue&type=style&index=0&id=306f7130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306f7130",
  null
  
)

export default component.exports